/* import __COLOCATED_TEMPLATE__ from './aria-tab-panel.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { importSync, macroCondition, dependencySatisfies } from "@embroider/macros";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let cached = macroCondition(dependencySatisfies('ember-source', '>= 4.1.0-alpha.0')) ? importSync('@glimmer/tracking').cached : importSync('ember-cached-decorator-polyfill').cached;
import { A } from '@ember/array';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
const DEFAULT_CLASS = 'ember-tabs__tab-panel';

/**
 * A tab panel component rendered as `<div />`.
 *
 * If you specify additional props on the `<AriaTabPanel />` component they will be forwarded to the rendered `<div />`.
 *
 * Default CSS class: `ember-tabs__tab-panel`
 *
 * @class AriaTabPanel
 * @public
 */
let AriaTabPanelComponent = (_class = class AriaTabPanelComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "elementId", _descriptor, this);
  }
  /**
   * Defaults to `"ember-tabs__tab-panel--selected"`.
   *
   * Provide a custom class name for the active tab panel.
   *
   * > This option can also be set for all `<AriaTabPanel />` components with the prop `selectedTabPanelClassName` on `<AriaTabs />`.
   *
   * @argument selectedClassName
   * @type String
   * @default "ember-tabs__tab-panel--selected"
   */
  get selectedClassName() {
    return this.args.selectedClassName ?? this.args.selectedTabPanelClassName ?? `${DEFAULT_CLASS}--selected`;
  }

  /**
   * Defaults to `false`.
   *
   * By default the tab content will only be rendered when the tab is active. If set to `true` the tab will also be rendered if inactive.
   *
   * > This can also be enabled for all `<AriaTabPanel />` components with the prop `forceRenderTabPanel` on `<AriaTabs />`.
   *
   * @argument forceRender
   * @type Boolean
   * @default false
   */

  get shouldYield() {
    return this.selected || this.args.forceRender;
  }
  get nodeIndex() {
    return A(this.args.panelIds).indexOf(this.elementId);
  }
  get tabId() {
    return A(this.args.tabIds)[this.nodeIndex];
  }
  get selected() {
    return this.nodeIndex === this.args.selectedIndex;
  }
  get classNames() {
    let classNames = [DEFAULT_CLASS];
    if (this.selected) {
      classNames.push(this.selectedClassName);
    }
    return classNames.join(' ');
  }
  didInsertNode(element) {
    this.elementId = element.id;
    if (typeof this.args.didInsertNode === 'function') {
      this.args.didInsertNode(this.elementId, ...arguments);
    }
  }
  willDestroyNode() {
    if (typeof this.args.willDestroyNode === 'function') {
      this.args.willDestroyNode(this.elementId, ...arguments);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "selectedClassName", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "selectedClassName"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "elementId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return guidFor(this);
  }
}), _applyDecoratedDescriptor(_class.prototype, "nodeIndex", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "nodeIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tabId", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "tabId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selected", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "selected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "classNames", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "classNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didInsertNode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsertNode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willDestroyNode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "willDestroyNode"), _class.prototype), _class);
export { AriaTabPanelComponent as default };